var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('field-label',_vm._b({},'field-label',_vm.labelProps,false)),_c('div',{staticClass:"text-field"},[(_vm.slugPrefix != null)?_c('span',{class:[
        'text-field__label',
        { 'is-disabled': _vm.disabled === true }
      ],domProps:{"textContent":_vm._s(_vm.slugPrefix)}}):_vm._e(),_c('v-text-field',_vm._b({class:[
        'text-field__input',
        { 'has-label': _vm.slugPrefix != null }
      ],attrs:{"value":_vm.localValue,"rules":_vm.localRules,"hint":_vm.localHint,"counter":_vm.counter,"size":_vm.counter,"type":_vm.type},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}},'v-text-field',Object.assign({}, _vm.defaultProps, _vm.$attrs),false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }